export default "__VITE_ASSET__VSH8x0eg__"